import { useState } from 'react'
import { Button } from 'react-bootstrap'
import Modal from 'components/Modal/Modal'
import Resize from 'components/Resize/Resize'
import NombreEtage from 'components/NombreEtage'
import { showCalculator, updateEtages } from 'redux/features/bienAVendre/slice'
import { useAppSelector, useAppDispatch } from 'redux/hooks'
import cn from 'classnames'
import {
  makeSelectEtages,
  makeSelectShowedCalculator,
} from 'redux/features/bienAVendre/selectors'
import s from './HouseFace.module.scss'

interface Props {
  onContinueButtonClick: () => void
  onBackButtonClick: () => void
}

const HouseFace = ({
  onContinueButtonClick,
  onBackButtonClick,
}: Props): JSX.Element => {
  const showedCalculator = useAppSelector(makeSelectShowedCalculator)
  const dispatch = useAppDispatch()
  const [etages, setEtages] = useState(useAppSelector(makeSelectEtages))

  const handleAddEtage = () => {
    const newEtage = [
      ...etages,
      {
        width: etages.length > 0 ? etages[0].width : 100,
        position: {
          x: etages.length > 0 ? etages[0].position.x : 0,
          y: 0,
        },
      },
    ]
    setEtages(newEtage)
    dispatch(updateEtages(newEtage))
  }

  const handleDeleteEtage = () => {
    const newEtage = etages.slice(1)
    setEtages(newEtage)
    dispatch(updateEtages(newEtage))
  }

  return (
    <Modal
      show={showedCalculator}
      title="Calculateur avancé de l'emprise au sol estimée"
      body={
        <>
          <h1 className={s.title}>
            A quoi ressemble la silouhette de la maison ?
          </h1>
          <p className={s.text}>
            Dessinez-la en ajoutant des niveaux et en redimensionnant les côtés
            des rectangles (cliquez sur un mur extérieur et faites-le glisser).
          </p>
          <div className={s.houseFace}>
            <span>Nombre d&apos;étages</span>
            <NombreEtage
              value={etages.length}
              onMinusClick={handleDeleteEtage}
              onPlusClick={handleAddEtage}
              min={0}
            />
          </div>
          <Resize etages={etages} setEtages={setEtages} />
          <p className={cn(s.text, s.helperText)}>
            <i>
              Exemple&nbsp;: si le rez-de-chaussée est 2 fois plus grand que le
              1<sup>er</sup> étage (garage attenant ou véranda), le niveau 1
              fait 100% et le niveau 2 fait 50%.
            </i>
          </p>
        </>
      }
      footer={
        <>
          <Button variant="outline-primary" onClick={onBackButtonClick}>
            Précédent
          </Button>
          <Button variant="primary" onClick={onContinueButtonClick}>
            Continuer
          </Button>
        </>
      }
      onCloseButtonClick={() => dispatch(showCalculator(false))}
    />
  )
}

export default HouseFace
